export default {"src":"/_next/static/image/public/images/ic_no_appointment.5fc84ba72e91c3b3ef52e5d969685733.svg","height":135,"width":153};